<p class="text-[12px] my-1">Sélectionnez un bénéficiaire pour charger ses prestations.</p>
@if (selectedPassport && getSelectedBeneficiaryName()) {
<p class="text-[12px] my-1 text-primary font-medium">Prestations de : {{ getSelectedBeneficiaryName() }}</p>
}
<div class="flex flex-wrap gap-2 mb-5">
	<button class="px-4 py-2 text-[12px] rounded-lg" [ngClass]="{
					'bg-primary text-white': selectedPassport === currentUser?.passportNumber,
					'bg-gray-200 text-gray-700 hover:bg-gray-300': selectedPassport !== currentUser?.passportNumber
				}" (click)="selectPassport(currentUser?.passportNumber)">Vous</button>
	@for (beneficiary of availableBeneficiaries; track beneficiary.passportNumber) {
	@if (beneficiary.passportNumber !== currentUser?.passportNumber) {
	<button class="px-4 py-2 text-[12px] rounded-lg" [ngClass]="{
									'bg-primary text-white': selectedPassport === beneficiary.passportNumber,
									'bg-gray-200 text-gray-700 hover:bg-gray-300': selectedPassport !== beneficiary.passportNumber
								}" (click)="selectPassport(beneficiary.passportNumber)">
		{{ beneficiary.fullname }}</button>
	}
	}
</div>


<!-- Error State -->
@if (error && !loading) {
<div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
	<div class="flex">
		<div class="flex-shrink-0">
			<svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
				<path fill-rule="evenodd"
					d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
					clip-rule="evenodd" />
			</svg>
		</div>
		<div class="ml-3">
			<h3 class="text-sm font-medium text-red-800">Erreur</h3>
			<div class="mt-2 text-sm text-red-700">
				<p>{{ error }}</p>
			</div>
		</div>
	</div>
</div>
}

<div class="flex items-center gap-x-2 mb-4">
	<label for="search" class="text-[12px]">Rechercher : </label>
	<input type="text" id="search" [(ngModel)]="searchTerm" (input)="onSearchChange()"
		class="placeholder:text-gray-300 text-[12px] rounded-lg border border-gray-300 w-[300px] p-2"
		placeholder="Rechercher une prestation..." />
</div>

<!-- Loading State -->
@if (loading) {
<div class="flex justify-center items-center py-8">
	<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
	<span class="ml-2 text-gray-600">Chargement des prestations...</span>
</div>
}
<!-- Prestations Table -->
@if (!loading && !error && filteredPrestations.length > 0) {
<div class="w-full overflow-x-auto">
	<table class="w-full divide-y divide-gray-200">
		<thead class="bg-gray-50">
			<tr>
				<th
					class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[150px]">
					Prestation
				</th>
				<th
					class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[120px]">
					Type
				</th>
				<th
					class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[100px]">
					Date
				</th>
				<th
					class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[150px]">
					Structure
				</th>
				<th
					class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider min-w-[150px]">
					Montant
				</th>
			</tr>
		</thead>
		<tbody class="bg-white divide-y divide-gray-200">
			@for (prestation of filteredPrestations; track prestation._id) {
			<tr class="hover:bg-gray-50 cursor-pointer" (click)="viewPrestationDetails(prestation)">
				<td class="px-4 py-4">
					<div class="flex items-center">
						<div class="flex-shrink-0 h-10">
							<div class="h-10 rounded-full bg-primary-100 flex items-center justify-center">
								<lucide-icon [img]="FileText" class="h-5 w-5 text-primary-600"></lucide-icon>
							</div>
						</div>
						<div class="ml-4">
							<div class="text-sm font-medium text-gray-900">
								{{ prestation.costumId || prestation.customId }}
							</div>
						</div>
					</div>
				</td>
				<td class="px-4 py-4">
					<div class="text-sm text-gray-900">
						{{ prestation.type?.label }}
					</div>
					<div class="text-sm text-gray-500">
						{{ prestation?.category?.label }}
					</div>
				</td>
				<td class="px-4 py-4">
					<div class="flex items-center text-sm text-gray-900">
						<lucide-icon [img]="Calendar" class="mr-1 h-4 w-4 text-gray-400"></lucide-icon>
						{{ formatDate(prestation.startDate) }}
					</div>
				</td>
				<td class="px-4 py-4">
					<div class="text-sm text-gray-900">
						{{ prestation.structure.name || 'Non spécifié' }}
					</div>
					@if (prestation.doctor?.completeName) {
					<div class="text-sm text-gray-500">
						Dr. {{ prestation.doctor?.completeName || 'Non spécifié' }}
					</div>
					}
				</td>
				<td class="px-4 py-4">
					<div class="text-sm text-gray-900">
						{{ prestation.amount !== undefined ? formatAmount(prestation.amount) : '--' }}
					</div>
					@if (prestation.careAmount > 0) {
					<div class="text-sm text-green-600">
						Prise en charge: {{ formatAmount(prestation.careAmount) }}
					</div>
					}
					@if (prestation.patientAmount > 0) {
					<div class="text-sm text-red-600">
						À payer: {{ formatAmount(prestation.patientAmount) }}
					</div>
					}
				</td>
			</tr>
			}
		</tbody>
	</table>
</div>

<!-- Pagination -->
@if (totalPages > 1) {
<div class="flex items-center justify-between mt-6">
	<div class="flex-1 flex justify-between sm:hidden">
		@if (currentPage > 1) {
		<button (click)="loadPrestations(currentPage - 1)"
			class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
			Précédent
		</button>
		}
		@if (currentPage < totalPages) { <button (click)="loadPrestations(currentPage + 1)"
			class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
			Suivant
			</button>
			}
	</div>
	<div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
		<div>
			<p class="text-sm text-gray-700">
				Affichage de
				<span class="font-medium">{{ (currentPage - 1) * itemsPerPage + 1 }}</span>
				à
				<span class="font-medium">{{ Math.min(currentPage * itemsPerPage, totalItems) }}</span>
				sur
				<span class="font-medium">{{ totalItems }}</span>
				résultats
			</p>
		</div>
		<div>
			<nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
				@if (currentPage > 1) {
				<button (click)="loadPrestations(currentPage - 1)"
					class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
					<span class="sr-only">Précédent</span>
					<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
						<path fill-rule="evenodd"
							d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
							clip-rule="evenodd" />
					</svg>
				</button>
				}
				@for (page of getPaginationArray(); track page) {
				<button (click)="loadPrestations(page)"
					class="relative inline-flex items-center px-4 py-2 border text-sm font-medium"
					[class]="page === currentPage ? 'z-10 bg-primary-50 border-primary-500 text-primary-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'">
					{{ page }}
				</button>
				}
				@if (currentPage < totalPages) { <button (click)="loadPrestations(currentPage + 1)"
					class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
					<span class="sr-only">Suivant</span>
					<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
						<path fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd" />
					</svg>
					</button>
					}
			</nav>
		</div>
	</div>
</div>
}
}

<!-- Empty State -->
@if (!loading && !error && filteredPrestations.length === 0) {
<div class="text-center py-12">
	<lucide-icon [img]="FileText" class="mx-auto h-12 w-12 text-gray-400"></lucide-icon>
	<h3 class="mt-2 text-sm font-medium text-gray-900">
		@if (searchTerm && searchTerm.trim() !== '') {
		Aucun résultat trouvé
		} @else {
		Aucune prestation
		}
	</h3>
	<p class="mt-1 text-sm text-gray-500">
		@if (searchTerm && searchTerm.trim() !== '') {
		Aucune prestation ne correspond à votre recherche "{{ searchTerm }}".
		} @else {
		Aucune prestation trouvée pour ce patient.
		}
	</p>
</div>
}